<template>
    <div class="mask">
        <div class="con" :class="(showHistory || showRules) ? 'red-con' : ''">
            <div class="close-confirm" @click="closeDialog"></div>
            <div class="recharge-box">
                <div class="recharge-title">
                    <div v-if="!showHistory && !showQrCode && !showRules">
                       <div class="buy-time-dialog">
                           <div class="buy-time-btn" :class="!showRecharge ? 'left-active' : ''" v-if="!is4399" @click="showRechargeFunc(false)">购买时长</div>
                           <div class="free-time-btn" :class="showRecharge ? 'right-active' : ''" @click="showRechargeFunc(true)">
                               <div v-if="missionCompleteStatus" class="has-red-point"></div>
                               免费领取时长
                           </div>
                       </div>
                    </div>
                    <div v-else>
                        <div class="recharge-title-div">
                            <div class="recharge-title-text">{{ showHistory ? '时长记录' : (showQrCode ? '完成支付' : (showRules ? '规则说明' : '')) }}</div>
                        </div>
                    </div>
                    <div class="recharge-title-history" @click="showOtherBox('showHistory', true)" v-if="!showHistory && !showQrCode && !showRules"></div>
<!--                    <div class="recharge-title-back" @click="showOtherBox('showHistory', false)" v-if="showHistory && !showQrCode && !showRules"></div>-->
                </div>
                <div v-if="!showHistory && !showQrCode && !showRules" class="recharge-main buy-time-content">
                    <div v-if="!showRecharge" class="buy-time-main">
                        <div v-for="product in productList" :key="product.id">
                            <div class="recharge-item" v-if="product.product_type != 3">
                                <div class="recharge-item-main">
                                    <img class="recharge-img-normal" :src="product.pc_icon" alt="">
                                    <div class="include-box">
                                        <div class="include-title">包含下列奖励</div>
                                        <img class="include-img" src="../assets/images/recharge/include-img.png" alt="">
                                        <div class="include-text">{{ product.describe }}</div>
                                    </div>
                                    <div class="gift-name">{{product.title}}</div>
                                </div>
                                <div class="buy-btn" @click="createOrder(product)">
                                    {{ (product.price / 100).toFixed(2) }}元
                                    <img v-if="product.tag_icon" class="buy-tip" :src="product.tag_icon"/>
                                </div>
                            </div>
                            <div class="recharge-item" v-else>
                                <div class="recharge-item-main single-item">
                                    <div>
                                        <div class="price-time">{{ price }}元/小时</div>
                                    </div>
                                    <div class="buy-num">
                                        <span class="reduce" @click="changeNum(-1)"></span>
                                        <div class="buy-result">{{ buyNum }}</div>
                                        <span class="add" @click="changeNum(1)"></span>
                                    </div>
                                    <div class="gift-name">购买时长</div>
                                </div>
                                <div class="buy-btn" @click="createOrder(product)">
                                    {{ (price * buyNum).toFixed(2) }}元
                                    <img v-if="product.tag_icon" class="buy-tip" :src="product.tag_icon"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="free-time-main buy-time-main">
                        <div class="buy-time-tips">
                            <div>免费时长上限：{{ parseInt(left_exp_time / 60) }} / 600</div>
                            <div style="color: #fff;text-decoration: #ffffff;text-decoration-line: underline;cursor: pointer;" @click="showOtherBox('showRules', true)">规则说明</div>
                        </div>
                        <div class="free-time-content">
                            <div class="task-box">
                                <div class="task-name">首次游玩云·生死狙击2</div>
                                <div class="task-list">
                                    <div v-for="task in firstTaskList" :key="task.mission_id" class="task-item">
                                        <div>{{ task.mission_name }}{{task.limit > 1 ? '(' + task.count + '/' + task.limit + ')' : ''}}</div>
                                        <div>免费时长+{{ parseInt(task.amount / 60) }}分钟</div>
                                        <div style="position: relative;">

                                            <!--                                            未完成-->
                                            <div v-show="task.status === 1" class="incomplete-btn task-btn"></div>
                                            <!--                                            可领取-->
                                            <div v-show="task.status === 2" class="can-recive task-btn" @click="reciveTask(task.mission_id)"></div>
                                            <!--                                            已领取-->
                                            <div v-show="task.status === 3" class="received-btn task-btn"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="task-box second-box">
                                <div class="task-name">端游登录领福利</div>
                                <div class="task-list">
                                    <div v-for="task in secondTaskList" :key="task.mission_id" class="task-item">
                                        <div>{{ task.mission_name }}{{task.limit > 1 ? '(' + task.count + '/' + task.limit + ')' : ''}}</div>
                                        <div>免费时长+{{ parseInt(task.amount / 60) }}分钟</div>
                                        <div style="position: relative;">

                                            <!--                                            未完成-->
                                            <div v-show="task.status === 1" class="incomplete-btn task-btn"></div>
                                            <!--                                            可领取-->
                                            <div v-show="task.status === 2" class="can-recive task-btn" @click="reciveTask(task.mission_id)"></div>
                                            <!--                                            已领取-->
                                            <div v-show="task.status === 3" class="received-btn task-btn"></div>
                                            <div class="download-client" @click="downloadClient"><span></span>下载客户端</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="task-box third-box">
                                <div class="task-name">
                                    <div>游玩云游戏送时长</div>
                                    <div style="font-size: 13px;color: red;">*仅统计云游戏环境下产生的对局数据，战斗结束后可能会存在结算延迟，请耐心等待~</div>
                                </div>
                                <div class="task-list">
                                    <div v-for="task in thirdTaskList" :key="task.mission_id" class="task-item">
                                        <div>{{ task.mission_name }}{{task.limit > 1 ? '(' + task.count + '/' + task.limit + ')' : ''}}</div>
                                        <div>免费时长+{{ parseInt(task.amount / 60) }}分钟</div>
                                        <div style="position: relative;">
<!--                                            未完成-->
                                            <div v-show="task.status === 1" class="incomplete-btn task-btn"></div>
<!--                                            可领取-->
                                            <div v-show="task.status === 2" class="can-recive task-btn" @click="reciveTask(task.mission_id)"></div>
<!--                                            已领取-->
                                            <div v-show="task.status === 3" class="received-btn task-btn"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showHistory" class="recharge-main-2">
                    <div>免费时长上限： {{ parseInt(left_exp_time / 60) }} /600</div>
                    <div>
                        <div class="history-item" v-for="(item, index) in historyList" :key="index">
                            <div class="history-left">{{ item.created_at }}</div>
                            <div class="history-right">{{ item.desc }}</div>
                        </div>
                    </div>
                    <div class="history-pagination">
                        <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :current-page="page"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
<!--                        <el-pagination-->
<!--                            @size-change="handleSizeChange"-->
<!--                            @current-change="handleCurrentChange"-->
<!--                            :current-page="page"-->
<!--                            :page-sizes="[10, 20, 30]"-->
<!--                            :page-size="page_size"-->
<!--                            layout="total, sizes, prev, pager, next, jumper"-->
<!--                            :total="total">-->
<!--                        </el-pagination>-->
                    </div>
                </div>
                <div v-if="showQrCode" class="recharge-main">
                    <div class="payment-method">
                        <div class="recharge-tabs">
                            <div class="recharge-tab recharge-tab-ali" :class="chooseTab === 1 ? 'choose-active' : ''" @click="chooseTabFunc(1)">
                                <div class="choose-icon"></div>
                                <div class="choose-ali-img"></div>
                                <div class="choose-ali-text">支付宝</div>
                            </div>
                            <div class="recharge-tab recharge-tab-wx" :class="chooseTab === 2 ? 'choose-active' : ''" @click="chooseTabFunc(2)">
                                <div class="choose-icon"></div>
                                <div class="choose-wx-img"></div>
                                <div class="choose-wx-text">微信</div>
                            </div>
                        </div>
                        <div class="recharge-img" :class="chooseTab === 1 ? 'ali-bg' : 'wx-bg'">
<!--                            <img :src="orderInfo.pay_link" alt="">-->
                            <vueQr
                                class="my-team-qr"
                                logo-src="https://rescdn.ssjj.cn/website/2022/03/10/836980d6d1b5a4775a70c3a3c5a4f345.png"
                                :text="orderInfo.pay_link"
                                color-dark="#000"
                                color-light="#e6e6e6"
                                :margin="0" />
                        </div>
                        <div class="complete-payment" @click="checkOrder">我已完成支付</div>
                    </div>
                </div>
                <div v-if="showRules" class="recharge-main rule-dialog">
                    <div class="rule-box">
                        <h2>《云·生死狙击2》计费规则</h2>
                        <br>
                        <p>探员您好，在《云·生死狙击2》内启动游戏时即开始计算游戏时长，根据游戏时长进行计费。计费细则如下：</p>
                        <br>
                        <p>1. 新玩家首次登录时，可获赠2小时的免费时长；每日登录《云·生死狙击2》后，还可领取30分钟的免费时长（每日凌晨0:00刷新）。免费时长累积上限为600分钟，达到600分钟上限后则无法继续累积。</p>
                        <br>
                        <p>2. 使用客户端登录游戏，即可获赠1小时免费体验时长（需在首次登录云游戏后31日内进行登录方可获得奖励）</p>
                        <br>
                        <p>3. 完成任务栏中的活跃任务，即可获取相应的免费时长，每个活跃任务仅可完成一次（需在首次登录云游戏后3个月内完成活跃任务方可获得奖励）</p>
                        <br>
                        <p>4. 开通酣战卡，在酣战卡生效期间无需免费时长即可畅玩游戏。</p>
                        <br>
                        <p>5. 购买付费时长：欢享礼包-10元/10小时。</p>
                        <br>
                        <p>6. 单独购买付费时长，计费标准为1.8元/小时</p>
                        <br>
                        <p>7. 若账户内有剩余免费时长，付费时长，以及生效中的畅玩卡，将按照【酣战卡】-【免费时长】-【付费时长】的顺序进行扣费。</p>
                    </div>
                    <div class="rule-btn" @click="gotoPrev">我知道了</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import vueQr from 'vue-qr';
import { secondsToTime } from '@/utils/util'
import { mapGetters, mapMutations } from 'vuex'
import { shouldRefreshAccountAfterMissionQuery } from '@/services/cloud-game/mission-account-refresh.mjs'
export default {
    props: {
        left_exp_time: {
            type: Number,
            default: 0
        },
        anti_level: {
            type: Number,
            default: 0
        },
        forbid_game: {
            type: Number,
            default: 1
        },
        downloadUrl: {
            type: String,
            default: ''
        },
    },
    computed: {
        ...mapGetters(['missionCompleteStatus', 'is4399'])
    },
    data () {
        return {
            firstTaskList: [],
            secondTaskList: [],
            thirdTaskList: [],
            price: '',
            buyNum: 1,
            showHistory: false,
            showQrCode: false,
            showRules: false,
            showRecharge: false,
            historyList: [],
            productList: [], // 产品列表
            productInfo: {}, // 产品信息
            orderInfo: {}, // 订单信息
            total: 0,
            page: 1,
            page_size: 10,
            chooseTab: 1,
            missionAccountRefreshRequested: false,

            // 支付信息
            product_id: '',
            result_price: '',
        }
    },
    components: {
        vueQr,
    },
    mounted () {
        this.queryHistoryList()
        this.queryTask()
        if (this.is4399) {
            this.showRecharge = true;
        } else {
            // 4399不用请求商品
            this.queryGoods()
        }
    },
    methods: {
        ...mapMutations(['setMissionCompleteStatus']),
        reciveTask (id) {
            this.$api.get('/v1/cloud/receive', { id }).then((res) => {
                console.log(res)
                this.$message.success('领取成功，获得【免费时长+' + parseInt(res / 60) + '分钟】！');
                this.queryTask();
                this.$emit("emitGetAccount")
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        downloadClient () {
            window.open(this.downloadUrl, '_blank');
        },
        createOrder (product) {
            this.productInfo = product;
            this.chooseTab = 1;
            this.queryQrCode()
        },
        checkOrder () {
            this.$api.post('/v1/cloud/check-order', {
                order_no: this.orderInfo.order_no,
            }).then((res) => {
                if (res.status === 1) {
                    this.showOtherBox('showQrCode', false)
                    this.closeDialog();
                    let str = ''
                    if (this.productInfo.amount_type == '1') {
                        str = `获得充值时长${secondsToTime(this.productInfo.amount * this.buyNum, 'time')}`
                    } else {
                        str = `获得充值时长${this.productInfo.amount}天`
                    }
                    this.$message(str);

                    this.$emit('rechargeSuccess')
                } else {
                    let map = {
                        0: '订单未支付',
                        1: '订单已支付',
                        2: '订单已关闭',
                        3: '订单超时状态',
                        500: '未知错误'
                    }
                    this.$message.error(map[res.status]);
                }
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        queryQrCode () {
            this.$api.post('/v1/cloud/create-order', {
                product_id: this.productInfo.id,
                price: this.productInfo.price,
                pay_type: this.chooseTab,
                is_web: 1,
                num: this.productInfo.product_type == '3' ? this.buyNum : 1,
            }).then((res) => {
                console.log(res)
                this.orderInfo = res;
                this.showOtherBox('showQrCode', true)
            }).catch((e) => {
                if (e.code == '430195') {
                    // 商品价格发生变化，需刷新产品列表
                    this.$emit('close');
                }
                this.$message.error(e.message);
            })
        },
        chooseTabFunc (val) {
           if (this.chooseTab != val) {
               this.chooseTab = val;
               this.queryQrCode();
           }
        },
        showOtherBox (val, status) {
            let arr = ['showHistory', 'showQrCode', 'showRules']
            arr.filter(function (action) {
                return action !== val
            }).forEach(str => {
                this[str] = false
            });
            this[val] = status
        },
        showRechargeFunc (val) {
           this.showRecharge = val;
        },
        gotoPrev () {
            this.showRules = false;
            this.showRecharge = true;
        },
        closeDialog (val) {
            this.$emit('close');
        },
        handleSizeChange (val) {
            console.log(`每页 ${val} 条`)
            this.page_size = val;
            this.queryHistoryList();
        },
        handleCurrentChange (val) {
            console.log(`当前页: ${val}`)
            this.page = val;
            this.queryHistoryList();
        },
        queryHistoryList () {
            // 通过接口获取客户端信息（含client token）
            this.$api.get('/v1/cloud/account-record', {
                page: this.page,
                page_size: this.page_size,
            }).then((res) => {
                console.log(res)
                this.historyList = res.items || []
                this.total = res.total
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        queryGoods () {
            // 通过接口获取客户端信息（含client token）
            this.$api.get('/v1/cloud/product-list', {}).then((res) => {
                console.log(res, '------');
                this.productList = res;
                res.forEach((product) => {
                    if (product.product_type == 3) {
                        this.price = (product.price / 100).toFixed(2);
                        this.buyNum = 1;
                    }
                })
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        queryTask () {
            // 通过接口获取客户端信息（含client token）
            this.$api.get('/v1/cloud/mission-list', {}).then((res) => {
                console.log(res, '------');
                let firstTaskList = [];
                let secondTaskList = [];
                let thirdTaskList = [];
                let missionStatus = false;
                res.forEach((item) => {
                    if (item.mission_id === 1) {
                        firstTaskList.push({ ...item })
                    } else if (item.mission_id === 2) {
                        secondTaskList.push({ ...item })
                    } else {
                        thirdTaskList.push({ ...item })
                    }
                    if (item.status === 2) {
                        missionStatus = true;
                    }
                })
                this.setMissionCompleteStatus(missionStatus);
                this.firstTaskList = firstTaskList;
                this.secondTaskList = secondTaskList;
                this.thirdTaskList = thirdTaskList;
                if (!this.missionAccountRefreshRequested && shouldRefreshAccountAfterMissionQuery(res, this.left_exp_time)) {
                    this.missionAccountRefreshRequested = true
                    this.$emit("emitGetAccount")
                }
            }).catch((e) => {
                this.$message.error(e.message);
            })
        },
        changeNum (num) {
            if (this.buyNum <= 1 && num < 0) {
                return
            }
            this.buyNum += num
        }
    },
}
</script>
<style lang="less" scoped>
.mask {
    position: fixed;
    z-index: 200;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    .complete-payment {
        width: 249px;
        height: 55px;
        background-image: url('@/assets/images/recharge/complete-payment.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        font-size: 26px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #B0CAEB;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        margin-top: 20px;
        cursor: pointer;
    }
    .recharge-img {
        width: 684px;
        height: 462px;
        background-image: url('@/assets/images/recharge/recharge-img-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .wx-bg {
        background-image: url('@/assets/images/recharge/recharge-wx-bg.png');
    }
    .choose-icon {
        width: 25px;
        height: 25px;
        background-image: url('@/assets/images/recharge/radio.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
    .choose-ali-img, .choose-wx-img {
        width: 25px;
        height: 25px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin: 0 10px;
    }
    .choose-ali-img {
        background-image: url('@/assets/images/recharge/radio-ali.png');
    }
    .choose-wx-img {
        background-image: url('@/assets/images/recharge/radio-wx.png');
    }
    .payment-method {
        width: 684px;
    }
    .recharge-tabs {
        display: flex;
        width: 100%;
        justify-content: space-between;
        .recharge-tab {
            width: 333px;
            cursor: pointer;
            height: 70px;
            font-size: 24px;
            font-weight: bold;
            background-image: url('@/assets/images/recharge/tab-normal.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
        }
        .recharge-tab-wx {
            background-image: url('@/assets/images/recharge/tab-choose.png') !important;
        }
    }
    .choose-active {
        .choose-icon {
            background-image: url('@/assets/images/recharge/radio-choose.png') !important;
        }
    }
    .history-pagination {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
        margin-right: 30px;
    }

    .history-item {
        display: flex;
        align-items: center;
        height: 55px;

        > div {
            width: 50%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #B0CAEB;
            font-size: 24px;
        }
    }

    .buy-title {
        color: #B0CAEB;
        font-size: 30px;
        font-weight: bold;
    }

    .buy-btn {
        width: 209px;
        cursor: pointer;
        height: 58px;
        background-image: url('@/assets/images/recharge/price-btn.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #8A5608;
        font-size: 25px;
        font-weight: 800;
        margin-top: 42px;
        position: relative;
        .buy-tip {
            position: absolute;
            width: 60px;
            height: 22px;
            right: 0;
            top: 0;
            transform: translateY(-50%);
        }
    }
    //.buy-btn:hover {
    //    background-image: url('@/assets/images/recharge/price-active-btn.png');
    //}

    .buy-num {
        display: flex;
        width: 100%;
        justify-content: space-around;
        align-items: center;
        color: #E33535;
        font-size: 40px;

        span {
            cursor: pointer;
        }
    }
    .gift-name {
        font-size: 24px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #EBB0B4;
        height: 61px;
        line-height: 61px;
    }
    .buy-result {
        font-size: 18px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #FF1D39;
        line-height: 21px;
    }

    .add, .reduce {
        display: block;
        width: 18px;
        height: 18px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .add {
        background-image: url('@/assets/images/recharge/add.png');
    }

    .reduce {
        background-image: url('@/assets/images/recharge/reduce.png');
    }

    .recharge-title-history {
        position: absolute;
        top: 40px;
        left: 40px;
        width: 157px;
        height: 47px;
        background-image: url('@/assets/images/recharge/recharge-history.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }
    .recharge-title-back {
        position: absolute;
        top: 40px;
        left: 40px;
        width: 59px;
        height: 59px;
        background-image: url('@/assets/images/recharge/back.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }

    .price-time {
        background-image: url('@/assets/images/recharge/price-singal.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        height: 35px;
        width: 128px;
        font-size: 18px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #7D3F03;
        margin-top: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .recharge-title-div {
        width: 1159px;
        height: 47px;
        background-image: url('@/assets/images/recharge/title.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        //padding-top: 30px;
        position: relative;
        margin: 0 auto;
        margin-top: 60px;
        color: #B0CAEB;
        font-size: 44px;
        font-weight: 800;
    }
    .recharge-title-text {
        background-image: url('@/assets/images/recharge/title-text.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding: 0 30px;
        width: 176px;
        font-size: 24px;
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translateX(-50%);
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 28px;
        margin: 0 auto;
    }

    .buy-time-content {
    }
    .recharge-main {
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        //align-items: space-around;
    }
    .rule-dialog {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        min-height: 0;
        padding: 32px 56px 34px;
        box-sizing: border-box;
    }
    .rule-box {
        flex: 1;
        width: 100%;
        min-height: 0;
        text-align: left;
        overflow-y: auto;
        padding: 22px 28px;
        box-sizing: border-box;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 1.55;
    }
    .rule-box h2 {
        margin: 0;
    }
    .rule-box p {
        margin: 0;
    }
    .rule-btn {
        background-image: url('@/assets/images/recharge/rule-btn.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
        font-size: 20px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        width: 150px;
        margin: 24px auto 0;
        flex-shrink: 0;
    }
    /deep/ .rule-box::-webkit-scrollbar {
        width: 2px;
    }
    .buy-time-main {
        display: flex;
        justify-content: space-around;
        flex-direction: row;
        width: 100%;
        height: 100%;
    }
    .free-time-main {
        height: 630px;
        display: flex;
        flex-direction: column;
        margin: 0 40px;
        background-image: url('@/assets/images/recharge/buy-time-dialog-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        padding-bottom: 4px;

        .free-time-content {
            height: 100%;
            overflow-y: auto;
            display: flex;
            flex-direction: column;
        }
        /deep/ .free-time-content::-webkit-scrollbar {
            width: 0;
        }
        .buy-time-tips {
            display: flex;
            justify-content: flex-end;
            margin: 18px 0;
            margin-right: 20px;
            >div {
                margin-left: 20px;
                font-size: 14px;
                font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                font-weight: 400;
                color: #F2C075;
            }
        }
    }

    .second-box {
        margin: 20px 0;
    }
    .third-box {
        flex: 1;
    }
    .task-box {
        background: rgba(153, 25, 39, 0.25);
        color: #ffffff;
        padding: 10px 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        .task-name {
            width: 25%;
        }
        .task-list {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width: 75%;
            .task-item {
                padding: 20px 0;
                width: 100%;
                display: flex;
                flex-direction: row;
                >div {
                    width: 33%;
                }
                .task-btn {
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    width: 90px;
                    height: 28px;
                    margin: 0 auto;
                }
                .can-recive {
                    cursor: pointer;
                    background-image: url('@/assets/images/recharge/can-recive.png');
                }
                .incomplete-btn {
                    background-image: url('@/assets/images/recharge/incomplete-btn.png');
                }
                .received-btn {
                    background-image: url('@/assets/images/recharge/received-btn.png');
                }
                .download-client {
                    position: absolute;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    right: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 12px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #FFFFFF;
                    span {
                        display: flex;
                        width: 14px;
                        height: 14px;
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        background-image: url('@/assets/images/recharge/download.png');
                    }
                }
            }
        }
    }
    .recharge-main-2 {
        display: flex;
        flex-direction: column;
        padding: 20px;
        justify-content: space-between;
        box-sizing: border-box;
        flex: 1;
    }

    .recharge-item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }
    .recharge-item-main {
        width: 304px;
        height: 384px;
        background-image: url('@/assets/images/recharge/recharge-item.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 10px 0 10px 0;
    }
    .single-item {
        padding: 30px 0 10px 0;
    }
    .recharge-img-normal {
        width: 270px;
        height: 160px;
    }
    .include-box {
        width: 100%;
    }
    .include-img {
        width: 316px;
        height: 21px;
        vertical-align: bottom;
    }
    .include-title {
        font-size: 16px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #EBB0B4;
        line-height: 19px;
    }

    .include-text {
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #EBB0B4;
        width: 90%;
        line-height: 25px;
        margin: 0 auto;
    }

    .recharge-box {
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
    }

    .recharge-title {
        margin-bottom: 45px;
    }
    .buy-time-dialog {
        width: 520px;
        margin: 0 auto;
        display: flex;
        padding: 40px 0;
        justify-content: center;
        >div {
            width: 260px;
            height: 63px;
            background-size: 100% 100%;
            background-repeat: no-repeat;
            cursor: pointer;
            color: #a99e9e;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 24px;
            font-family: Microsoft YaHei-Bold, Microsoft YaHei;
            font-weight: bold;
            line-height: 28px;
        }
        .buy-time-btn {
            background-image: url('@/assets/images/recharge/left-tab.png');
        }
        .free-time-btn {
            position: relative;
            background-image: url('@/assets/images/recharge/right-tab.png');
        }
        .has-red-point {
            position: absolute;
            width: 14px;
            height: 14px;
            opacity: 1;
            border: 1px solid #FFFFFF;
            border-radius: 50%;
            background: #BB2232;
            right: -7px;
            top: -7px;
        }
        .left-active {
            background-image: url('@/assets/images/recharge/left-tab-active.png');
            color: #ffffff;
        }
        .right-active {
            background-image: url('@/assets/images/recharge/right-tab-active.png');
            color: #ffffff;
        }
        .active {
            //background-image: url('@/assets/images/recharge/buy-time-btn-active.png');
            color: #F4DFC4;
        }
    }

    .con {
        width: 1509px;
        height: 840px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;
        font-weight: 500;
        font-size: 22px;
        color: #808080;
        box-sizing: border-box;
        padding: 10px;
        background-image: url('@/assets/images/recharge/dialog-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        font-family: "微软雅黑";

        .close-confirm {
            position: absolute;
            right: -60px;
            top: 0;
            cursor: pointer;
            width: 50px;
            height: 50px;
            background-image: url("@/assets/images/close-confirm.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
    }
    .red-con {
        background-image: url('@/assets/images/recharge/dialog-bg-red.png');
    }
}
</style>
